<template>
    <v-app id="register">
        <v-main v-if="!isBusyValidateToken">
            <v-container v-if="isValidToken" fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-card class="elevation-12 rounded">
                            <v-img src="@/assets/img/login-header.png"></v-img>
                            <v-card-title class="pa-6">You've been invited to register!</v-card-title>
                            <v-card-text class="px-6">
                                <v-form ref="formData" class="form-data" @submit.prevent="register()">
                                    <v-row>
                                        <v-col class="my-0 py-0" md="12">
                                            <label for="email" class="font-weight-medium">Email Address</label>
                                            <v-text-field v-model="formData.email" class="ma-0 pa-0 for-email" name="email" type="text" solo dense disabled></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="my-0">
                                        <v-col md="6">
                                            <label for="first_name" class="font-weight-medium">First Name</label>
                                            <v-text-field
                                                v-model="formData.first_name"
                                                name="first_name"
                                                type="text"
                                                placeholder="eg. John"
                                                :class="[{ 'is-invalid': errors.first_name, 'has-color': getColorClass(formData.first_name) }]"
                                                :error-messages="errors.first_name"
                                                hide-details="auto"
                                                solo
                                                dense
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col md="6">
                                            <label for="last_name" class="font-weight-medium">Last Name</label>
                                            <v-text-field
                                                v-model="formData.last_name"
                                                name="last_name"
                                                type="text"
                                                placeholder="eg. Doe"
                                                :class="[{ 'is-invalid': errors.last_name, 'has-color': getColorClass(formData.first_name) }]"
                                                :error-messages="errors.last_name"
                                                hide-details="auto"
                                                solo
                                                dense
                                                required
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="my-0">
                                        <v-col md="12">
                                            <label for="password" class="font-weight-medium">Password</label>
                                            <v-text-field
                                                :type="showPassword ? 'text' : 'password'"
                                                v-model="formData.password"
                                                :class="[{ 'is-invalid': errors.password }]"
                                                :error-messages="errors.password"
                                                hide-details="auto"
                                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                @click:append="showPassword = !showPassword"
                                                autocomplete="nope"
                                                placeholder="Enter password"
                                                solo
                                                dense
                                                required
                                            ></v-text-field>
                                            <div class="red--text">{{ errorMessage }}</div>
                                        </v-col>
                                        <v-col md="12">
                                            <div class="password-requirement mb-6">Password must contain at least one uppercase letter, one lowercase letter, one number and one special character</div>
                                            <label for="confirm_password" class="font-weight-medium">Confirm Password</label>
                                            <v-text-field
                                                :type="showPasswordConfirmation ? 'text' : 'password'"
                                                v-model="formData.password_confirmation"
                                                :class="[{ 'is-invalid': errors.password_confirmation }]"
                                                :error-messages="errors.password_confirmation"
                                                hide-details="auto"
                                                :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                                                @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                                                autocomplete="nope"
                                                placeholder="Enter password"
                                                solo
                                                dense
                                                required
                                            ></v-text-field>
                                            <div class="red--text">{{ errorMessage }}</div>
                                        </v-col>
                                    </v-row>

                                    <div class="red--text">{{ errorMessage }}</div>
                                    <v-btn type="submit" block class="btn-register mt-4" color="primary">Create Account</v-btn>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-dialog v-model="successDialog.show" scrollable max-width="550" color="primaryBackgroundColor" transition="scroll-y-reverse-transition" persistent>
                    <v-card class="confirm-dialog text-center py-10">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon class="dialog-close" v-on="on" @click="successDialog.show = false">close</v-icon>
                            </template>
                            <span>Close</span>
                        </v-tooltip>
                        <img class="icon-registration-success" src="@/assets/img/registration-success.svg" />
                        <v-card-text class="pb-2">
                            <h2 class="content-title pb-5">
                                {{ successDialog.data.title }}
                            </h2>
                            <p class="content-description ma-0">
                                {{ successDialog.data.description }}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-container>
            <ErrorPage v-else />
        </v-main>
    </v-app>
</template>

<script>
import ErrorPage from '@/components/Core/ErrorPage.vue';

export default {
    name: 'login',
    components: {
        ErrorPage
    },
    data() {
        return {
            showPassword: false,
            showPasswordConfirmation: false,
            formData: {
                status: false,
                loading: false,
                error: '',
                email: '',
                first_name: '',
                last_name: '',
                password: '',
                password_confirmation: '',
                role_id: ''
            },
            isValidToken: false,
            isBusyValidateToken: true,
            successDialog: {
                show: false,
                data: {
                    title: '',
                    description: 'Your account has been successfully created. In a moment, you will be redirected to the dashboard. '
                }
            },
            errorMessage: ''
        };
    },
    computed: {
        query() {
            return this.$route.query;
        },
        userInfo() {
            return this.$store.getters['authentication/getUserInfo'];
        }
    },
    methods: {
        register() {
            let formStatus = this.$refs.formData.validate();

            if (formStatus && !this.formData.loading) {
                let { first_name, last_name, password, password_confirmation } = this.formData;
                const token = this.query?.token || '';
                this.formData.error = '';
                this.formData.loading = true;

                const config = {
                    headers: { Authorization: `Bearer ${token}` }
                };

                this.$store
                    .dispatch('authentication/registerUser', { config: config, data: { token, first_name, last_name, password, password_confirmation } })
                    .then((response) => {
                        const { access_token } = response;

                        this.$cookies.set('token', access_token);
                        this.$api.setAuthorization(window.atob(access_token));

                        const config = {
                            params: { appends: ['role', 'permissions', 'merchant'] }
                        };

                        this.$store
                            .dispatch('authentication/fetchUserInfo', { config: config })
                            .then((response) => {
                                const { role, first_name, last_name } = response.data;

                                this.$cookies.set('user-info', window.btoa(JSON.stringify({ role, first_name, last_name })));
                                const fullName = first_name + ' ' + last_name;
                                this.successDialog.data.title = `Congratulations, ${fullName}!`;
                                this.successDialog.show = true;

                                setTimeout(() => {
                                    this.$router.push({ name: 'default-layout' });
                                }, 4500);

                                this.formData.loading = false;
                            })
                            .catch(() => {
                                this.formData.loading = false;
                            });
                    })
                    .catch((error) => {
                        this.formData.loading = false;
                        this.formData.error = error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message || 'Login Error';
                    });
            }
        },
        async validateToken() {
            const token = this.query?.token || '';
            const config = {
                headers: { Authorization: `Bearer ${token}` }
                // params: { appends: ['role', 'permissions', 'merchant'] }
            };

            this.$store
                .dispatch('authentication/validateRegistrationToken', {
                    config: config,
                    data: {
                        token: token,
                        get_user: true
                    }
                })
                .then((response) => {
                    if (response && response.data) {
                        const { email, first_name, last_name } = this.userInfo;
                        this.formData.email = email;
                        this.formData.first_name = first_name;
                        this.formData.last_name = last_name;

                        this.isValidToken = true;
                        this.isBusyValidateToken = false;
                    }
                })
                .catch(() => {
                    this.isBusyValidateToken = false;
                });
        },
        redirect() {
            this.formData.loading = false;
        },
        getColorClass(value) {
            if (value === null) return null;
            return value.replace(/\s/g, '').length === 0 ? false : true;
        }
    },
    mounted() {
        this.validateToken();
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.confirm-dialog {
    .content-title {
        color: #16192c !important;
        font-weight: bold !important;
    }

    .content-description {
        color: #425466;
        font-size: 1.17em;
        font-weight: 500;
    }

    .dialog-close {
        color: #16192c99;
    }
}

#register {
    .v-text-field {
        &.theme--light {
            .v-input__slot {
                background-color: var(--v-secondaryBackgroundColor-base);
            }
        }

        &.theme--dark {
            .v-input__slot {
                background-color: var(--v-secondaryBackgroundColor-base);
            }
        }
    }

    &::v-deep {
        .text {
            margin: 20px 0 0 0;
            text-transform: uppercase;
            font-size: 12px;

            span {
                color: #0984e3;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        .password-requirement {
            color: #425466;
            font-weight: 500;
        }

        .v-card__title {
            color: #16192c;
        }
        label {
            color: #425466;
        }
        .v-input__slot {
            // background-color: #edf2f7;
            color: #16192c;

            input {
                // color: #b5b5bd;
            }
        }
        .for-email {
            .v-input__slot {
                background-color: #edf2f7;
            }
            input {
                &:disabled {
                    color: #16192c;
                    font-weight: bold;
                }
            }
        }
        .has-color {
            input {
                color: #16192c;
            }
        }
        .password-white-bg {
            .v-input__slot {
                background-color: #fff;
            }
        }
    }
}

.icon-registration-success {
    height: 80px;
    margin: 20px auto;
}
</style>
